/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_view = /** @type {(inputs: {}) => string} */ () => {
	return `Zobrazit`
};

const da_view = /** @type {(inputs: {}) => string} */ () => {
	return `Se`
};

const de_view = /** @type {(inputs: {}) => string} */ () => {
	return `Ansehen`
};

const en_view = /** @type {(inputs: {}) => string} */ () => {
	return `View`
};

const es_view = /** @type {(inputs: {}) => string} */ () => {
	return `Ver`
};

const fr_view = /** @type {(inputs: {}) => string} */ () => {
	return `Voir`
};

const hu_view = /** @type {(inputs: {}) => string} */ () => {
	return `Megtekintés`
};

const it_view = /** @type {(inputs: {}) => string} */ () => {
	return `Vedi`
};

const nl_view = /** @type {(inputs: {}) => string} */ () => {
	return `Bekijken`
};

const pl_view = /** @type {(inputs: {}) => string} */ () => {
	return `Zobacz`
};

const pt_view = /** @type {(inputs: {}) => string} */ () => {
	return `Ver`
};

const sv_view = /** @type {(inputs: {}) => string} */ () => {
	return `Visa`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const view = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.view(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("view", locale)
	if (locale === "cs") return cs_view(inputs)
	if (locale === "da") return da_view(inputs)
	if (locale === "de") return de_view(inputs)
	if (locale === "en") return en_view(inputs)
	if (locale === "es") return es_view(inputs)
	if (locale === "fr") return fr_view(inputs)
	if (locale === "hu") return hu_view(inputs)
	if (locale === "it") return it_view(inputs)
	if (locale === "nl") return nl_view(inputs)
	if (locale === "pl") return pl_view(inputs)
	if (locale === "pt") return pt_view(inputs)
	return sv_view(inputs)
};